export default {"src":"/_next/static/media/spiritoryLogo.1dbd94db.svg","height":474,"width":473,"blurWidth":0,"blurHeight":0};